// TILT - Frontend

// HUOM! Muista kehitysvaiheen ja tuontantovaiheen backend urlin vaihto App.js ja login.js tiedostoissa

// TODO:
// - Kaikkien locationeiden uusimmat mittaukset heti startissa
// - Luo Dockerfile Scalewayhyn (api.savcor.com) tcp_receiver_inclinometer.py:lle. Kun tomii kontissa, siirrä se mcadex.savcor.comiin

//import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'

import Overview from './components/Overview';
import Maintenance from './components/Maintenance';
import Admin from './components/Admin';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import 'bootstrap/dist/css/bootstrap.min.css';

import { io } from 'socket.io-client';

import loginService from './services/login';

//import SavcorLogo from './SavcorLogo2018.svg';

var socket = null;

//const backend_url = 'http://10.20.2.36:6087';
const backend_url = 'https://wireless.savcor.com';



function App() {
  //const SERVER = "https://mcadex.savcor.com/influx"

  const [ selectedUser, setSelectedUser ] = useState(null);
  //const [ selectedLocation, setSelectedLocation ] = useState(null);
  //const [ selectedDevice, setSelectedDevice ] = useState(null);

  const [ users, setUsers ] = useState([]);
  const [ devices, setDevices ] = useState([]);
  const [ locations, setLocations ] = useState([]);
  const [ links, setLinks ] = useState([]);
  const [ sites, setSites ] = useState([]);

  const [ measurements, setMeasurements ] = useState([]);
  const [ lastMeasurements, setLastMeasurements ] = useState({}); // Map

  //const [ lastQuery, setLastQuery ] = useState({});

  const [ online, setOnline ] = useState(true);


  // Loginiin liittyvät
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [user, setUser] = useState(null);

  const [userLevel, setUserLevel] = useState(1); // 1=View, 2=Maintenance, 3=Admin
  const [userOrg, setUserOrg] = useState(0); // 0=all,1=Savcor, 2=HSY



  // 
  const [ lastQuery, setLastQuery ] = useState({}); // Viimeisin käytetty query
  const lastQueryRef = useRef(lastQuery);

  
  useEffect(() => {
    lastQueryRef.current = lastQuery;
  }, [lastQuery]);



  const [ lastLocation, setLastLocation ] = useState(null);


  // Localstorageen tallennetut käyttäjätiedot
  /* Siirretty configurationin haun jälkeen
  useEffect(() => {
    const loggedUserJSON = window.localStorage.getItem('loggedUser');

    if (loggedUserJSON) {
      const user = JSON.parse(loggedUserJSON);
      setUser(user);
      console.log('user:1 = ', user)
      console.log('user:users=', users)
      console.log('user:selected=', selectedUser)
    }
  }, []);
  */


  // Login buttonia painettu. Tarkistetaan onko käyttää ja mitkä sen oikeudet on.
  // LoginService tekee kyselyn backendiin /api/login, joka antaa vastaukset.
  const handleLogin = async (event) => {
    console.log('NYT HandleLogin')
    
    event.preventDefault();
    console.log('logging in with', username, password)

    try {
      const user = await loginService({
        username, password
      })

      window.localStorage.setItem(
        'loggedUser', JSON.stringify(user)
      );
      console.log('login - handlelogin user:', user)
      console.log('login - handlelogin config/users:', users)

      // Tarkistetaan löytyykö username configurationista (users=configuration['users])
      let foundUser = users.find(x => x.username === user.username);
      console.log('login - handlelogin found user:', foundUser)


      if (foundUser['role'] === "admin")
        setUserLevel(3);
      if (foundUser['role'] === "maint")
        setUserLevel(2);
      if (foundUser['role'] === "view")
        setUserLevel(1);

      setUser(user);
      //setUserLevel(user.level); // Tämä tieto olisi jo userissa...
      setUserOrg(user.organization); // ... niin kuin tämäkin

      // TODO: Tämä on nyt päällekkäistä 
      setSelectedUser(foundUser);

      setUsername('');
      setPassword('');
    } catch (exception) {
      //setErrorMessage('wrong credentials');
      console.log('error wrong credentials')
      
    }

  }
//  <div className="logo" style={{padding: '5px', marginTop: '10px', marginLeft: '10px', align:'center'}} >

  // Apufunktiot
  const loginForm = () => (

    <>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        verticalAlign: 'center',
        horizontalAlign: 'center',
        alignContent: 'center',
        justifyContent: 'center',
      }}>


        <br/>

        <div>
          <form onSubmit={handleLogin}>
          <div>
            
              <input
              type="text"
              value={username}
              name="Username"
              placeholder="Käyttäjätunnus"
              onChange={({ target }) => setUsername(target.value)}
            />
          </div>
          <div>
            
              <input
              type="password"
              value={password}
              name="Password"
              placeholder="Salasana"
              onChange={({ target }) => setPassword(target.value)}
            />
          </div>
          <button className="btn btn-primary" type="submit" style={{marginTop: '10px'}}>login</button>

          </form>      
        </div>
      </div>
    </>
  )
















  const queryHistory = (args) => {
    // Päivitetään samalla historiakäppyrät
    console.log('päivittää historiaa', args, ' *** ')

    console.log('lastQuery', lastQuery)
    console.log('lastQuery ref', lastQueryRef.current)
    console.log('lastlocation', lastLocation)

    var lastQueryEmpty = Object.keys(lastQueryRef.current).length === 0;
    

    //let query = backend_url + '/history'
    let query = `${backend_url}/history`;
    if (args)
      query = `${query}?begin=${args['begin']}&end=${args['end']}&interval=${args['interval']}&location=${args['location_id']}&device=${args['device_id']}`;
    else if (!lastQueryEmpty && lastQueryRef.current) 
      query = `${query}?begin=${lastQueryRef.current['begin']}&end=${lastQueryRef.current['end']}&interval=${lastQueryRef.current['interval']}&location=${lastQueryRef.current['location_id']}&device=${lastQueryRef.current['device_id']}`;

    axios.get( query )
      .then(response => {
        console.log('päivittää ja sai vastauksen query:', query)
        console.log('päivittää ja sai vastauksen', response.data)

        console.log('päivittää kok*:', response.data, '/', JSON.parse(response.data).length)
/*
        console.log('online:', online)
          //if (!online) {

            let count_measurements = JSON.parse(response.data).length;
            if (count_measurements > 0) {
              let last = JSON.parse(response.data)[count_measurements - 1];
              //console.log('päivittää viimeinen:', last)
            
              //let updatedLastInfo = JSON.parse(JSON.stringify(lastInfo));
              //updatedLastInfo[last['sensor']] = last;         

              //console.log('päivittää uusi:', updatedLastInfo);
              // Välimuisti kaikkien laitteiden viimiselle mittaukselle

                console.log('last1:', online, last)
              // TODO: Tämä näytettävässä infoboxissa maintenance sivulla kalibrointia varten
              // TODO: Pitäisikö huomioida myös käppyrässä?
                console.log('last2:', last)
                let sensor = last['sensor'];

                let test = lastMeasurements[sensor];
                lastMeasurements[sensor] = last;
                //console.log('CACHE:', lastMeasurements)
                //console.log('CACHE viimseisin', last)
                setLastMeasurements(lastMeasurements);
                console.log('online lastmeasurements', lastMeasurements)
            }
          //}
          //else {
*/
          //}

        setMeasurements(response.data);
      })
  }

  const queryOnline = (args) => {
    // Päivitetään samalla historiakäppyrät
    console.log('päivittää onlinea', args)

    //let query = backend_url + '/history'
    let query = `${backend_url}/online`;
    //if (args)
    //  query = `${query}?begin=${args['begin']}&end=${args['end']}&interval=${args['interval']}&location=${args['location_id']}&device=${args['device_id']}`;

    axios.get( query )
      .then(response => {
        console.log('päivittää ja sai vastauksen online:', query)
        console.log('päivittää ja sai vastauksen', response.data)

        console.log('päivittää kok*:', response.data, '/', JSON.parse(response.data).length)
/*
        console.log('online:', online)
          //if (!online) {

            let count_measurements = JSON.parse(response.data).length;
            if (count_measurements > 0) {
              let last = JSON.parse(response.data)[count_measurements - 1];
              //console.log('päivittää viimeinen:', last)
            
              //let updatedLastInfo = JSON.parse(JSON.stringify(lastInfo));
              //updatedLastInfo[last['sensor']] = last;         

              //console.log('päivittää uusi:', updatedLastInfo);
              // Välimuisti kaikkien laitteiden viimiselle mittaukselle

                console.log('last1:', online, last)
              // TODO: Tämä näytettävässä infoboxissa maintenance sivulla kalibrointia varten
              // TODO: Pitäisikö huomioida myös käppyrässä?
                console.log('last2:', last)
                let sensor = last['sensor'];

                let test = lastMeasurements[sensor];
                lastMeasurements[sensor] = last;
                //console.log('CACHE:', lastMeasurements)
                //console.log('CACHE viimseisin', last)
                setLastMeasurements(lastMeasurements);
                console.log('online lastmeasurements', lastMeasurements)
            }
          //}
          //else {
*/
          //}

        setMeasurements(response.data);
      })
  }


  const queryLastMeasurements = () => {
    let query = `${backend_url}/lastmeasurements`;

    axios.get( query )
      .then(response => {
        console.log('päivittää ja sai vastauksen lastmeasurements:', query)
        console.log('päivittää ja sai vastauksen lastmeasurements', response.data)

        console.log('päivittää kok*:', response.data, '/', JSON.parse(response.data).length)

          //if (!online) {

            let last_measurements = JSON.parse(response.data);

            last_measurements.forEach(element => {
              if (element['device_id'] != "None" && element['location_id'] != "None") {
              //console.log('päivittää:', element['sensor'])
                let sensor = element['sensor'];
                lastMeasurements[sensor] = element;
              }
              
            });


      })

  }


  useEffect(() => {

    // Haetaan käyttäjän konfiguraatio
    // Haetaan datahistoria
    /*
    axios.get(backend_url + '/history')
      .then(response => {
        console.log('last history',response.data)
        setMeasurements(response.data);

        // Napataan vielä viimeisin tietokannasta tullut mittaus ja asetetaan se lastInfoksi. 
        // Tämä siksi koska ei tiedetä tuleeko uusia mittauksia välttämättä koskaan joltain laitteelta.
        // Saadaan ainakin jotain mittareihin ja muualle.

        // Käy läpi kaikki laitteet (addressien perusteella) ja jakaa ne mappeihin
        var latest = {};

        let parsedHistory = JSON.parse(response.data);
        console.log('parsehistory 1:', parsedHistory)
        //console.log('parsehistory:', test)
        //if (parsedHistory !== undefined && parsedHistory.length > 0) {
          for (const [key, value] of Object.entries(parsedHistory)) {

            console.log('parsehistory 2:', key)
            console.log('parsehistory 3:', value)
          
            if (parsedHistory[key] !== undefined && parsedHistory[key].length > 0) {
              let parsedAsString = parsedHistory[key][parsedHistory[key].length - 1];

              //latest = latest.concat
              //latest.set(key, parsedAsString);
              //if (latest[key] == undefined) {
              //  latest[key] = [];
              //}

              latest[key] = parsedAsString;
            }

          }
        //}

        
        //let parsedHistory = JSON.parse(response.data)['100000005'];
        //if (parsedHistory !== undefined && parsedHistory.length > 0) {
          //let parsedAsString = parsedHistory[parsedHistory.length - 1];
          //console.log('last meas:', JSON.stringify(parsedAsString) )
          

          console.log('parsehistory 4:', latest)
          console.log('parsehistory 5:', JSON.stringify(latest))
          //setLastInfo(JSON.stringify(parsedAsString));
          setLastInfo(latest);
        //}
      })
*/
    // Haetaan config
    axios.get(backend_url + '/configuration')
      .then(response => {
        console.log('axios get configuration')
        console.log('axios  response:', response)
        console.log('axios  response users:', response.data['users'])
        console.log('axios  response devices:', response.data['devices'])
        console.log('axios  response locations:', response.data['locations'])
        console.log('axios  response links:', response.data['links'])

        //console.log('response users:', response.data['users'])
        setUsers(response.data['users']);
        setDevices(response.data['devices']);
        setLocations(response.data['locations']);
        setLinks(response.data['links']);
        setSites(response.data['sites']);


        // Asetetaan aktiivinen käyttäjä
        // Tämä tulee todellisuudessa kirjautumisessa
        

        //console.log('axios users:', response.data['users'], ' response:', response)
        if (response.data['users'].length > 0) {
          //setSelectedUser(response.data['users'][0]);
          console.log('user:3:', user, '/users:', response.data['users'] )



          // Haetaan selaimen localStoragesta kirjautuneen käyttäjän tiedot
          const loggedUserJSON = window.localStorage.getItem('loggedUser');

          if (loggedUserJSON) {
            const user = JSON.parse(loggedUserJSON);
            setUser(user);

            let tmpUsers = response.data['users'];

            let foundUser = tmpUsers.find(x => x.username === user.username);
            if (foundUser['role'] === "admin")
              setUserLevel(3);
            if (foundUser['role'] === "maint")
              setUserLevel(2);
            if (foundUser['role'] === "view")
              setUserLevel(1);

            setSelectedUser(foundUser);

            console.log('user:1 = ', user, '/ found:', foundUser)
            console.log('user:users=', users)
            console.log('user:selected=', selectedUser)
          }          
        }

      })

    // Haetaan kaikkien laitteiden viimeisimmät mittaukset
    queryLastMeasurements()


    // Asetetaan aktiivinen käyttäjä
    // Tämä tulee todellisuudessa kirjautumisessa
    //setSelectedUser(10000);


      // Muodostetaan socket-yhteys
      socket = io(backend_url);
      
      // Backend lähettää viimeisimmän mittauksen. Tapahtuu kun datan vastaanottaja lähettää mittaukset backendille.
      // Vastaanottaja lähettää mqtt:llä backendille mittauksen ja samalla kirjoittaa erikseen Influx tietokantaan.
      socket.on('measurements', (message) => {

        console.log('lastmeasurements type', typeof(message))
        console.log('measurements:', message)
        //setLastMeasurements(JSON.parse(message));
        
        // {"sensor":"100000005","x_angle":"+000.2722","y_angle":"-000.1355","z_angle":"+089.6959","x_acceleration":"+000.0048","y_acceleration":"-000.0024","z_acceleration":"+001.0026","temperature":"+028.8674","battery_level":"4","phone_number":"1000000000000"}
        //console.log('setLastMeasurements:', message['sensor'], '=>', message)


          let last_sensor_parsed = JSON.parse(message);
          let sensor = last_sensor_parsed['sensor'];
          lastMeasurements[sensor] = last_sensor_parsed;
          console.log('CACHE:', lastMeasurements)
          console.log('CACHE valittu location', lastQuery )
          //console.log('CACHE viimseisin', last)
          setLastMeasurements(lastMeasurements);


/*
        // Päivitetään samalla historiakäppyrät
        console.log('päivittää historiaa')
        axios.get(backend_url + '/history')
          .then(response => {
            console.log('päivittää ja sai vastauksen')
            //console.log(response.data)
            setMeasurements(response.data);
          })
            */

          // TODO: Tämä kaataa appin. Pitiäsi olla argumentteja
          // Päivitetään historiatietoa ainoastaan kun ollaan online-tilassa,
          // ja silloinkin haetaan x ajalta
          //if (online)
          //  queryOnline();
          //else
          queryHistory();
          // TODO: Toimiiko tämä riittävän hyvin?

      })

      // Backendiltä komento
      socket.on('command', (message) => {
        if (message === 'configurationupdated') {
        // Haetaan config. TODO: Tämä sama kuin aikaisemmin. Pitäisikö siirtää omaan funktioonsa?
        axios.get(backend_url + '/configuration')
          .then(response => {
            //console.log('response users:', response.data['users'])
            setUsers(response.data['users']);
            setDevices(response.data['devices']);
            setLocations(response.data['locations']);
            setLinks(response.data['links']);
            setSites(response.data['sites']);
          })
        }
      })

  }, []);


  // Callback-funktio, jota kutsutaan jostain komponentista
  const event_from_child = (action, sender, data) =>  {
    console.log('Heippa! dataa lapselta', action, sender, data);//, socket);
    console.log('action:', action)

    // Komennot lähetetään backendille socketilla
    if (action === 'command') {
      // Lähetään data backendiin
      if (socket) {
        console.log('miksi ei lähde:', action, data)
        socket.emit(action, data);
      }
    }

    // Queryt (tietokantakyselyt) tehdään hakuina suoraan backendin rest-rajapinnasta
    else if (action === 'query') {
      console.log('query:', typeof(data), data)
      setLastLocation(data['location_id']);
      setLastQuery(data);
      //console.log('lastQuery1', lastQuery)
      queryHistory(data);
      //setLastQuery(data);
    }

    
  }




/*
  const overviewForm = () => {
    return (
      //<Maintenance disabled database={database} main_callback={event_from_child}>Testataan miten toimii</Maintenance>
      <Overview users={users} selectedUser={selectedUser} locations={locations} devices={devices} database={measurements} lastmeasurements={lastMeasurements} callback={event_from_child} >Testataan miten toimii</Overview>
    )
  }

  const maintenanceForm = () => {
    return (
      <div>
        <Maintenance users={users} selectedUser={selectedUser} devices={devices} locations={locations} links={links} lastmeasurements={lastMeasurements} callback={event_from_child}/>
      </div>
    )
  } 
  
  const adminForm = () => {
    return (
      <Admin users={users} devices={devices} locations={locations} links={links} callback={event_from_child}/>
    )
  }
*/

  const mainForm = () => {
    

  const overviewForm = () => {
    return (
      //<Maintenance disabled database={database} main_callback={event_from_child}>Testataan miten toimii</Maintenance>
      <Overview users={users} selectedUser={selectedUser} sites={sites} locations={locations} devices={devices} database={measurements} lastmeasurements={lastMeasurements} callback={event_from_child} >Testataan miten toimii</Overview>
    )
  }

  const maintenanceForm = () => {
    return (
      <div>
        <Maintenance users={users} selectedUser={selectedUser} devices={devices} locations={locations} sites={sites} links={links} lastmeasurements={lastMeasurements} callback={event_from_child}/>
      </div>
    )
  } 
  
  const adminForm = () => {
    return (
      <Admin users={users} devices={devices} locations={locations} links={links} callback={event_from_child}/>
    )
      
  }



  return (
    <>
    <div className="App">




      <Tabs
        defaultActiveKey="overview"
        id="uncontrolled-tab-example"
        className="mb-3"
        fill
      >

        <Tab eventKey="overview" title={"Overview"}>
          { overviewForm() }
        </Tab>

        <Tab eventKey="maintenance" title="Maintenance" disabled={userLevel !== 3 && userLevel !== 2}>
          { maintenanceForm() }
        </Tab>

        <Tab eventKey="admin" title="Admin" disabled={userLevel !== 3}>
          { adminForm() }
        </Tab>

      </Tabs>

        {/* Oikean alakulman logout-nappi */}
        <div className="logout" style={{ marginRight: '10px' }} >
          <button class="btn btn-primary" type="button" onClick={() => { window.localStorage.removeItem('loggedUser'); setUser('') }}>logout</button>
        </div>


      <center><em>Savcor 2025</em></center>
    </div>
    </>
  );    

  }




  return (
    <div className="App">
      <header className="Tilt">

      </header>

      <main>
        
        {/* Näytetään logoform jos ei olla sisäänkirjautuneena, muuten pääformi. */}
        
        {!user && loginForm()}
        {user && mainForm()}

        {/* Kaikilla sivuilla näkyvä alareunan teksti */}
        <div>
          <br />
          <center className="company"><em>Savcor 2025</em></center>
        </div>

      </main>
    </div>
  );



}

export default App;
